const MuiListItemIcon = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      color: theme.palette.grey[800],
      minWidth: theme.spacing(4.5)
    })
  }
};
export default MuiListItemIcon;